const allowedDomains = process.env.ALLOWED_DIAMOND_VIDEO_DOMAINS?.split(',') || [
  'loupe360.com',
  's3.amazonaws.com',
  'v360.in',
  'www.filesonsky.com',
  'view.gem360.in'
];

// Regular expressions for specific domains
const validLoupe360UrlRegex = /(\d+)\/(\d+)(?:\/\d+\/\d+)?(?:\/autoplay)?/i; //  loupe360.com
const validS3UrlRegex = /[?&](d=|s=|v=|sv=|z=|btn=)/i; // s3.amazonaws.com
const validV360UrlRegex = /(\d+)\/(\w+)\.html\?d=\d+/i; // v360.in
const validFilesOnSkyUrlRegex = /(\d+)\/(\w+)\.HTML\?d=\d+/i; // www.filesonsky.com
const validViewGem360UrlRegex = /^(https:\/\/view\.gem360\.in\/gem360\/\d+-\w+\/gem360-\d+-\w+\.html|https:\/\/view\.gem360\.in\/gem360\.html\?d=\d+-\w+-\w+|https:\/\/view\.gem360\.in\/gem360\.html\?d=\d+-\w+(-\w+)?)$/i;

/**
 *
 * @param videoUrl the 'videourl' attribute of the diamond object
 * @returns 'true' if the URL contains an allowed domain and matches the format. Otherwise returns 'false'.
 */
export const hasValidVideoUrlFormat = (videoUrl: string | null | undefined) => {

  if (allowedDomains.length === 0) {
    console.log('No allowed domains configured.');
    return false;
  }

  if (!videoUrl) {
    console.log('Video URL is null or undefined.');
    return false;
  }

  const matchedDomain = allowedDomains.find(domain => videoUrl.includes(domain));
  if (!matchedDomain) {
    return false;
  }

  let validUrlFormat = false;
  
  if (matchedDomain === 'loupe360.com') {
    validUrlFormat = validLoupe360UrlRegex.test(videoUrl);
  } else if (matchedDomain === 's3.amazonaws.com') {
    validUrlFormat = validS3UrlRegex.test(videoUrl);
  } else if (matchedDomain === 'v360.in') {
    validUrlFormat = validV360UrlRegex.test(videoUrl);
  } else if (matchedDomain === 'www.filesonsky.com') {
    validUrlFormat = validFilesOnSkyUrlRegex.test(videoUrl);
  } else if (matchedDomain === 'view.gem360.in') {
    validUrlFormat = validViewGem360UrlRegex.test(videoUrl);
  }

  return !!matchedDomain && validUrlFormat;
}

/**
 *
 * @param videoUrl the 'videourl' attribute of the diamond object
 * @param size the device size
 * @returns transformed video url
 */
export const transformedVideoUrl = (videoUrl: string, size?: string) => {

  const domain = allowedDomains.find(d => videoUrl.includes(d));
  if (!domain) {
    return videoUrl; 
  }

  let transformedUrl = videoUrl;

  if (domain === 'loupe360.com') {
    if (size) {
      transformedUrl = videoUrl.replace(validLoupe360UrlRegex, `${size}/${size}/autoplay`);
    } else {
      transformedUrl = videoUrl.replace(validLoupe360UrlRegex, '500/500/autoplay');
    }
  } else if (domain === 's3.amazonaws.com' || domain === 'v360.in' || domain === 'www.filesonsky.com' || domain === 'view.gem360.in') {
    const url = new URL(videoUrl);
    url.searchParams.set('btn', '0');
    url.searchParams.set('z', '0');
    url.searchParams.set('autoplay', '1');
    url.searchParams.set('s', '0');
    url.searchParams.set('v', '0');
    url.searchParams.set('sv', '0');
    url.searchParams.set('zoomslide', '0');
    url.searchParams.set('isBorderRadius', '0');
    transformedUrl = url.toString();
  }

  return transformedUrl;
}
